import "./style.scss";

interface MenuButtonProps {
  text?: string;
  onClick: () => void;
  variant?: "menu" | "arrow-left";
}

export const MenuButton = ({
  text = "Items",
  onClick,
  variant = "menu",
}: MenuButtonProps) => {
  return (
    <div className="menu-button" onClick={onClick}>
      <div className="menu-button__icon">
        {variant === "menu" ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
          >
            <path
              d="M6.13802 4.49976H14.8047M6.13802 8.49976H14.8047M6.13802 12.4998H14.8047M2.80469 4.49976H2.81135M2.80469 8.49976H2.81135M2.80469 12.4998H2.81135"
              stroke="white"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
          >
            <path
              d="M13.5 8.5H3.5M3.5 8.5L7.5 4.5M3.5 8.5L7.5 12.5"
              stroke="white"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      <span>{text}</span>
    </div>
  );
};
